import { useCallback, useMemo } from 'react';
import { Select, SelectProps } from 'antd';
import { observer } from 'mobx-react-lite';

import { TTrainType } from '../../core/train-types';

type _SelectProps = Omit<SelectProps, 'value' | 'onChange'>;

type TrainTypesOption = Pick<TTrainType, 'id' | 'nameRu'> & {
  [key: string]: any;
};

type SelectValue = { id: number } | null;

type TrainTypesSelectProps = {
  value?: SelectValue;
  onChange?: (trainType: SelectValue) => void;
  trainTypes?: TrainTypesOption[];
} & _SelectProps;

type SelectOption = NonNullable<SelectProps['options']>[number];

export const TrainTypesSelect = observer(
  ({ value, onChange, trainTypes = [], ...props }: TrainTypesSelectProps) => {
    const options = useMemo<SelectOption[]>(() => {
      const result = trainTypes.map((type) => ({
        value: type.id,
        label: type.nameRu,
      }));

      return result;
    }, [trainTypes]);

    const providedValue = value?.id;

    const handleOnChange = useCallback(
      (id: number | undefined) => {
        const value = id == undefined ? null : { id };

        onChange?.(value);
      },
      [onChange],
    );

    return (
      <Select
        value={providedValue}
        options={options}
        onChange={handleOnChange}
        style={{ width: '100%' }}
        {...props}
      />
    );
  },
);
